<template>
    <div v-if="productInfo.supportid" class="container">
        <div class="item-headder">
            <img class="image" :src="productInfo.imgurl" draggable="false"/>
            <div>
                <h2>{{productInfo.title}}</h2>
                <p>{{productInfo.description}} - {{productInfo.supportid}}</p>
            </div>
        </div>
        <h2>Productinformation</h2>
        <div class="div-table row">
            <div>
                <p>Support ID</p>
                <span>
                    {{productInfo.supportid}}
                </span>
            </div>
            <div>
                <p>Product type</p>
                <span>
                    {{productInfo.title}}
                </span>
            </div>
            <div>
                <p>Description</p>
                <span>
                    <input type="text" v-model="productInfo.description"/>
                </span>
            </div>
            <div>
                <p>Setting</p>
                <span>
                    <input type="number" v-model="productInfo.settings" min="0"/>
                </span>
            </div>
            <div>
                <p>Discount (%)</p>
                <span>
                    <input type="number" v-model="productInfo.discount" min="0" max="100"/>
                </span>
            </div>
            <div>
                <p>Force server</p>
                <span>
                    {{productInfo.forceserver}}
                </span>
            </div>
            <div>
                <p>Status</p>
                <span>
                    <span class="pill xl green" v-if="productInfo.status == 'active'">Active</span>
                    <span class="pill xl" v-if="productInfo.status == 'inactive'">Inactive</span>
                    <span class="pill xl" v-if="productInfo.status == 'suspended'">Suspended</span>
                    <span class="pill xl red" v-if="productInfo.status == 'deleted'">Deleted</span>


                </span>
            </div>
            <div>
                <p>Created</p>
                <span>
                    {{dateTimeFormat(productInfo.creation)}}
                </span>
            </div>
            <div>
                <p>Delete</p>
                <span>
                    {{dateTimeFormat(productInfo.deletion)}}
                </span>
            </div>
            <div>
                <p>Autorenew</p>
                <span>
                    <div class="btn sm" :class="{'selected main' : (productInfo.autorenew == 'true')}" v-on:click="productInfo.autorenew = 'true'">
                        Active
                    </div>
                    <div class="btn sm" :class="{'selected main' : (productInfo.autorenew == 'false')}" v-on:click="productInfo.autorenew = 'false'">
                        Inactive
                    </div>
                </span>
            </div>
        </div>
        <div class="action-panel">
            <div class="btn" v-on:click="saveProductData()">Save changes</div>
        </div>
    </div>
    <Loading v-else/>
</template>
<script>
import Loading from '@/components/parts/Loading.vue';
export default {
    name: 'Product',
    components: { Loading },
    data() {
        return {
            productInfo: {},
        }
    },
    methods: {
        getProductData(){
            var vue = this;
            this.$socket.client.emit('getProductInfo',vue.$route.params.productid, (error, response) => {
                if(error=='200'){
                    vue.productInfo = response;
                }
            })
        },
        savedResponse(error, response){
            //OK = 200
            //Error = 204
            console.log("save data- "+error);
            console.log(response);
            if(error == 200){
                document.getElementById("Toast1").classList.remove("red");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("green");
                document.getElementById("Toast1").innerText = "The changes was saved";
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
            }else{
                document.getElementById("Toast1").classList.remove("green");
                document.getElementById("Toast1").classList.remove("hide");
                document.getElementById("Toast1").classList.add("red");
                document.getElementById("Toast1").innerText = "Could not save changes. Errorcode " + error;
                setTimeout(function() {
                    document.getElementById("Toast1").classList.add("hide");
                }, 3000);
            }
        },
        saveProductData(){
            var vue = this;
            this.$socket.client.emit('setProductInfo',vue.productInfo, (error, response) => {
                vue.savedResponse(error, response);
            })
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        }
    },
    mounted() {
        this.getProductData();
    },
}
</script>